<app-toolbar [attr.hidden]="!(authenticated$ | async)" (logout)="logout()" (open)="sidenav.toggle()" (close)="sidenav.toggle()"></app-toolbar>
<mat-sidenav-container #root [dir]="dir" fullscreen>
  <mat-sidenav #sidenav mode="push" [(opened)]="opened" style="box-shadow: 3px 0 6px rgba(0,0,0,.24);">
    <app-sidenav></app-sidenav>
  </mat-sidenav>
  <mat-sidenav-content #content>
    <!-- <mat-card>
				Main Theme:
				<button mat-fab color="primary">
					Primary
				</button>
				<button mat-button color="accent">
					Accent
				</button>
				<button mat-raised-button color="warn">
					Warning
				</button>
			</mat-card> -->
    <!-- <ngx-loading-bar [includeSpinner]="false" [color]="'white'" [height]="'3px'"></ngx-loading-bar> -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
